import React from 'react'
import './commercial_properties.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, Faq, SuccessStories,
    BussinessForm, FindAgent, OneBlueCard
} from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const CommercialProperties = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Commercial property insurance", link: "" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Our commercial property insurance policies",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];
    const bluecarddata = {
        heading1: '',
        para1: 'General liability insurance coverage is the foundation of your business’s liability protection. Our general liability insurance helps protect your large or small business from losses caused by your services, operations, or employees. This type of protection helps cover medical expenses, legal expenses, and damages included in your policy.',
        para2: 'As a business owner, general liability insurance helps protect your bottom line, so you can focus on running your company.',
        blue_card_heading: 'Learn more about our general liability coverage.',
        blue_card_para: 'We’ll work with you to build a general liability coverage plan that makes sense for you and your employees.',
        button_text: "Let's talk"
    }
    const sectrydata = {
        banner: images['two_people_smiling_and_looking_at_laptop.avif'],
        heading: 'The Sentry difference',
        subheading: 'Liability insurance for your business',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'We’ve been protecting businesses since 1904',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['gearsblue.svg']
    }
    const plansData = {
        blue_heading: 'Keeping up with a changing business world',
        blue_para: 'As the business world incorporates new technology, insurance providers need to keep pace. With coverages for electronic data processing, computer-related losses, and more, we’re doing exactly that.',
        purple_icon: images['icon_of_two_purple_boots.svg'],
        purple_heading: 'Unique solutions for unique situations',
        purple_para: "When you file a claim, you’ll be assigned a claims specialist who’s knowledgeable about your industry and your policy type. This experience and claims expertise helps us reach claims resolutions that are fair and equitable.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Crime insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about business liability insurance >',
        },
        {
            id: 2,
            title: 'Inland marine insurance',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about commercial umbrella insurance >',
        },
        {
            id: 3,
            title: 'Business personal property insurance',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about E&O insurance >',
        },

    ];

    return (
        <>
            <div className='commercial_properties'>
                {/* hero section */}
                <Hero img={images["exterior_of_office_building.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Commercial property insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />
                    {/* Layout */}
                    <OneBlueCard data={bluecarddata} />
                    {/* the sentry card */}
                    <SentryCard data={sectrydata} />
                    {/* Plans section */}
                    <Plans heading="The Sentry difference" data={plansData} />
                    {/* news card section */}
                    <NewsCard Title="Our commercial property insurance policies:" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} />
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <BussinessForm />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default CommercialProperties;